export const modalConstants = {
  DEFAULT: "DEFAULT",
  NUMBER_INPUT_FIELD: "NUMBER_INPUT_FIELD",
};
